var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-8"},[_c('container',[_c('row',[_c('column',{staticClass:"w-full"},[_c('main-title',{attrs:{"type":"primary"}},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }